module.exports = __webpack_public_path__ + "img/34g-config-modelos-doc-wizard-integracao.cede4205.png";